import React from 'react'
import classNames from 'classnames'

const Loader = ({ spinning = true, fullScreen = true }) => (
  <div
    className={classNames('loader', {
      hidden: !spinning,
      fullscreen: fullScreen,
    })}
  />
)
export default Loader
